import { isBasketItemExpired } from './isBasketItemExpired';

type HoldLike = {
  bookable?: { status?: string | null } | null;
  expireAt?: string | null;
};

export const isBasketItemHeld = (item: HoldLike | null | undefined, now = Date.now()): boolean =>
  !!item &&
  item.bookable?.status !== 'failed' &&
  typeof item.expireAt === 'string' &&
  !Number.isNaN(Date.parse(item.expireAt)) &&
  !isBasketItemExpired(item, now);
